import React, { useCallback, useMemo } from 'react'
import { Flex, Text } from '@chakra-ui/react'
import { ListarInfoPosNota } from '../../../services/api/index'
import TabelaImpressaoNota from './components/TabelaImpressaoNota'
import { HeadingPages } from '../../../components/HeadingPages'
import { Filtro } from './components/Filtro'
import { format } from 'date-fns'
import { MaisNFModal } from './components/MaisNFModal'

function ImpressaoNota() {
  const [dados, setDados] = React.useState([])
  const [loading, setLoading] = React.useState(false)

  const buscarInfoPorNota = useCallback(async (filter) => {
    try {
      const params = {
        codigo_parceiro: filter.codParc,
        numero_pedido: filter.pedido,
        data_entrada: filter.dataDe,
        data_saida: filter.dataAte,
        pendente: filter.pendente,
        nfe: filter.nfe,
      }

      setLoading(true)

      const response = await ListarInfoPosNota.post('', params)
      var dados = []
      var data = response.data

      data.map((data) => {
        var preco_home = Math.round(parseFloat(data.valor_nota) * 100) / 100

        if (isNaN(preco_home)) {
          preco_home = 0.0
        }

        dados.push({
          ...data,
          cod_parc: data.cod_parc,
          data_pronto: data.data_pronto,
          data_saida: data.data_saida ? format(new Date(data.data_saida), 'dd/MM/yyyy HH:mm') : '',
          tipo_envio: data.tipo_transporte,
          nome_parc: data.nome_parc,
          nome_vendedor: data.nome_vendedor,
          numero_pedido: data.numero_pedido,
          numero_unico: data.numero_pedido,
          numero_nota: data.numero_nota,
          numero_nota_show: data.numero_nota,
          peso_total: data.peso_total,
          quantidades_caixa: data.quantidades_caixa,
          status_pendencia: data.status_pendencia,
          data_atualizacao: data.data_atualizacao,
          nota_remessa: data.nota_remessa,
          valor_nota: (Math.round(parseFloat(preco_home) * 100) / 100).toLocaleString('pt-br', {
            minimumFractionDigits: 2,
          }),
          remessa: data.remessa,
          link_boleto: data.link_boleto,
          codigo_produto: data.codigo_produto,
          sequencia: data.sequencia,
          valida_etiqueta: data.valida_etiqueta,
          codigo_kangu: data.codigo_kangu,
          boletos: data.boletos,
          link_layout: data.link_layout,
          saida_materiais: data.data_saida ? format(new Date(data.data_saida), 'dd/MM/yyyy HH:mm') : '',
          limite_producao: data.data_limite ? format(new Date(data.data_limite), 'dd/MM/yyyy HH:mm') : '',
          //valor nao pode ser maior que 3000 para ser j3
          isJ3: data.tipo_transporte === 'Nosso Carro' && parseInt(data.quantidades_caixa) === 1 && parseFloat(data.valor_nota) <= 3000,
          valida_tracken: data.valida_tracken,
        })
      })

      const dataSemDuplicados = dados.filter((item, index, self) => {
        return index === self.findIndex((t) => t.numero_pedido === item.numero_pedido)
      })

      setDados(dataSemDuplicados)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(Object.keys(error), error.message)
    }
  }, [])

  //lista de dados com useMemo
  const dadosMemo = useMemo(() => {
    return dados
  }, [dados])

  //chama a função buscarInfoPorNota

  React.useEffect(() => {
    buscarInfoPorNota({
      codParc: '',
      pedido: '',
      dataDe: '',
      dataAte: '',
      pendente: '',
      nfe: '',
    })
  }, [buscarInfoPorNota])

  const counterNumPed = dadosMemo.filter((item, index, self) => self.findIndex((t) => t.numero_unico === item.numero_unico) === index).length

  return (
    <>
      <HeadingPages name={'Impressão de Notas'} />
      <Filtro resultado={buscarInfoPorNota} />
      <Flex alignItems="center" justifyContent="space-between" mx={'1rem'}>
        <Text fontSize="1.2rem" fontWeight="bold" color="#606163" marginLeft={'1rem'} mb={'1rem'}>
          {counterNumPed} Pedidos
        </Text>

        <MaisNFModal />
      </Flex>
      <TabelaImpressaoNota view_loading_update={loading} resultado={buscarInfoPorNota} dados={dadosMemo} />
    </>
  )
}

export default ImpressaoNota
